<mat-card>
  <app-kanban-view
    [items]="items()"
    [kanbanColumns]="kanbanColumns"
    [groupDefiner]="'statusCategory'"
  ></app-kanban-view>
</mat-card>
